
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useCreationState = () => {
  const location = useLocation();
  const [isCreating, setIsCreating] = useState(false);

  // Check URL parameters for create mode
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    if (params.get('create') === 'true') {
      setIsCreating(true);
    } else {
      setIsCreating(false);
    }
  }, [location]);

  const handleCreateClick = () => {
    if (isCreating) {
      // If we're already in create mode, this acts as cancel
      setIsCreating(false);
      // Update URL without navigating
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('create');
      window.history.pushState({}, '', newUrl.toString());
    } else {
      // Switch to create mode
      setIsCreating(true);
      // Update URL without navigating
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.set('create', 'true');
      window.history.pushState({}, '', newUrl.toString());
    }
  };

  const handleCreateSuccess = () => {
    setIsCreating(false);
    // Update URL without navigating
    const newUrl = new URL(window.location.href);
    newUrl.searchParams.delete('create');
    window.history.pushState({}, '', newUrl.toString());
  };

  return {
    isCreating,
    handleCreateClick,
    handleCreateSuccess
  };
};
